import { render, staticRenderFns } from "./CharacterCreator.vue?vue&type=template&id=57b8057b&scoped=true&"
import script from "./CharacterCreator.vue?vue&type=script&lang=js&"
export * from "./CharacterCreator.vue?vue&type=script&lang=js&"
import style0 from "./CharacterCreator.vue?vue&type=style&index=0&id=57b8057b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b8057b",
  null
  
)

export default component.exports